import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  margin: 1rem 0;

  select {
    width: 100%;
    border-color: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
  }
`;
